( function( $ ) {

    $(document).ready( function() {

        if ($('.wp-block-st-fullwidth-content-slider').length > 0) {

            $('.wp-block-st-fullwidth-content-slider .splide').each(function(index) {

                let mouseDown = false;
                let startX, scrollLeft;
                const sliderNav = $(this).find('.wp-block-st-fullwidth-content-slider__nav')[0];
                const $sliderNav = $(this).find('.wp-block-st-fullwidth-content-slider__nav-wrapper');

                const startDragging = (e) => {
                mouseDown = true;
                startX = e.pageX - sliderNav.offsetLeft;
                scrollLeft = sliderNav.scrollLeft;
                }

                const stopDragging = (e) => {
                mouseDown = false;
                }

                const move = (e) => {
                e.preventDefault();
                if(!mouseDown) { return; }
                const x = e.pageX - sliderNav.offsetLeft;
                const scroll = x - startX;
                sliderNav.scrollLeft = scrollLeft - scroll;
                }

                // Add the event listeners
                sliderNav.addEventListener('mousemove', move, false);
                sliderNav.addEventListener('mousedown', startDragging, false);
                sliderNav.addEventListener('mouseup', stopDragging, false);
                sliderNav.addEventListener('mouseleave', stopDragging, false)

                function updateNavPosition() {
                    $sliderNav.find('.wp-block-st-fullwidth-content-slider__nav-item').each(function() {
                        let offsetLeft = $(this).offset().left;
                        $(this).attr('data-offset', offsetLeft);
                    });
                }

                updateNavPosition();

                $(window).on('resize', function() {
                    updateNavPosition();
                });

                // Get the unique key for this slider based on page URL and index
                const storageKey = 'st_slider_active_index_' + window.location.pathname + '_' + index;
                const savedIndex = sessionStorage.getItem(storageKey);

                // Log for debugging
                // console.log('Slider init', { index, storageKey, savedIndex });

                let contentSlider = new Splide( $(this)[0], {
                    type   : 'fade',
                    perPage: 1,
                    pagination: false,
                    arrows: true,
                    // We try to start at the saved index, but we'll also enforce it in mounted
                    start: savedIndex !== null ? parseInt(savedIndex, 10) : 0,
                } );

                const updateUI = () => {
                    $sliderNav.find('.wp-block-st-fullwidth-content-slider__nav-link').removeClass('is-active');
                    $sliderNav.find('.wp-block-st-fullwidth-content-slider__nav-link[data-slide="' + contentSlider.index + '"]').addClass('is-active');

                    let scroll = $sliderNav.find('.wp-block-st-fullwidth-content-slider__nav-link[data-slide="' + contentSlider.index + '"]').parent().attr('data-offset');
                    
                    if (scroll !== undefined) {
                        let offset = scroll - 30;
                        sliderNav.scroll({
                            left: offset,
                            top: 0,
                            behavior: 'smooth'
                        });
                    }
                };

                contentSlider.on( 'mounted', function () {
                    // Force go to saved index if it exists, to ensure state is correct
                    if (savedIndex !== null) {
                        const idx = parseInt(savedIndex, 10);
                        if (contentSlider.index !== idx) {
                            contentSlider.go(idx);
                        }
                    }
                    updateUI();

                    contentSlider.on( 'moved', function () {
                        // Save the current index to session storage
                        sessionStorage.setItem(storageKey, contentSlider.index);
                        updateUI();
                    } );
                });

                contentSlider.mount();

                $sliderNav.find('.wp-block-st-fullwidth-content-slider__nav-link').on('click', function(e) {
                    e.preventDefault();

                    $sliderNav.find('.wp-block-st-fullwidth-content-slider__nav-link').removeClass('is-active');
                    $(this).addClass('is-active');
                    contentSlider.go($(this).data('slide'));
                });

                

            });

        }

    } );

} )( jQuery );
